export const defaultColorSchemeColor = "#000000";
